module.exports = new __parcel__URL__("exercise5.7615fb04.png").toString();